<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
import {getDiffEnvConfig} from '@/config/env'
import rrlog from '@meibao/traceback-record'
import {initSLS} from '@/util/aliyunSlsUtils'
import sensorsUtils from './util/sensorsUtils'

export default {
	name: 'App',
	data() {
		return {}
	},
	computed: {},
	watch: {},
	created() {
		//获取配置项
		let {VUE_APP_RRLOG_ID, VUE_APP_RRLOG_URL, VUE_APP_SENSORS_URL} = getDiffEnvConfig()
		console.log('执行回溯！！！！', VUE_APP_RRLOG_ID, VUE_APP_RRLOG_URL, VUE_APP_SENSORS_URL)
		// 测试代码初始化
		rrlog.init(VUE_APP_RRLOG_ID, {api_host: VUE_APP_RRLOG_URL, recordCrossOriginIframes: true})
		// recordCrossOriginIframes,是否记录跨域的iframe，默认为false, 如果需要记录跨域iframe，需要设置recordCrossOriginIframes为true，parent和iframe都要设置true
		// 初始化神策
		sensorsUtils.initSensors()
		// 初始化SLS
		initSLS()
	},
	methods: {},
}
</script>
<style lang="scss">
#app {
	width: 100%;
	height: 100%;
	overflow: hidden;
}

.vue-treeselect__input {
	font-size: 14px !important;
	color: #606266;
}

.vue-treeselect__label-container {
	.vue-treeselect__label {
		font-size: 14px;
		color: #606266;
	}
}

.avue-crud__right {
	.is-circle {
		border-radius: 4px !important;
		border: initial !important;
		background: #f6f8fa;
		box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.1);
	}

	button {
		&:hover {
			background: #deefff;
		}
	}

	span {
		color: #333;
	}

	i {
		&::before {
			color: #333;
		}
	}

	.el-icon-download {
		&:after {
			margin-left: 4px;
			content: '下载';
			color: #333;
			font-weight: bold;
		}
	}
	.el-icon-download-all {
		&:after {
			margin-left: 4px;
			content: '下载全部';
			color: #333;
			font-weight: bold;
		}
	}

	.el-icon-download-emp {
		&:after {
			margin-left: 4px;
			content: '下载人员清单';
			color: #333;
			font-weight: bold;
		}
	}

	.el-icon-refresh {
		&:after {
			margin-left: 4px;
			content: '刷新';
			color: #333;
			font-weight: bold;
		}
	}

	.el-icon-s-operation {
		&:after {
			margin-left: 4px;
			content: '筛选';
			color: #333;
			font-weight: bold;
		}
	}

	.el-icon-search {
		&:after {
			margin-left: 4px;
			color: #333;
			font-weight: bold;
			content: '搜索';
		}
	}
}

//上传模态框的样式
.import-content {
	display: flex;
	justify-content: center;
	margin-top: 20px;

	.upload-import-text-main {
		display: flex;
		flex-direction: column;
		align-items: center;

		span {
			&:nth-child(1) {
				font-size: 16px;
				color: rgba(0, 0, 0, 0.85);
			}

			&:nth-child(2) {
				font-size: 14px;
				margin-top: 12px;
				color: rgba(0, 0, 0, 0.45);
			}
		}
	}
}

.red-bold {
	font-weight: bold;
	color: red;
}

.year-report-dialog {
	overflow: hidden !important;

	.year_report_main {
		width: 100vw;
		height: initial;
		background: url('/img/bg/year_poster_bg.png') 100% 100% no-repeat;
		background-size: 100% 100%;
		display: flex;
		justify-content: center;
		position: absolute;
		left: 0;
		top: 0;
	}

	.close-icon {
		right: 1vw !important;
	}

	.el-dialog {
		margin-top: 0 !important;
		margin: 0;
	}

	iframe {
		height: 100vh !important;
		width: 52.63vh !important;
	}
}

h4 {
	margin: 0;
	font-size: 1.05em;
}

h3 {
	margin: 10px 0;
}

h2 {
	margin: 10px 0;
}

.center_info_content {
	p,
	span,
	strong,
	a,
	td,
	tr {
		font-size: 16px !important;
	}
}
</style>
